export const aboutData = {
  brandName: 'j9官方平台',
  brandIntro: '备受用户信赖的综合娱乐平台',
  description:
    'j9平台成立于2018年，是业内领先的综合娱乐服务平台。我们致力于为全球用户提供安全、公平、优质的在线娱乐体验。经过多年的深耕与发展，j9平台已累计服务超过500万注册用户，成为行业标杆品牌。',
  mission:
    '以用户为中心，以技术为驱动，打造全球最值得信赖的综合娱乐平台，让每一位用户都能在这里享受到极致的娱乐体验。',
  values: [
    {
      title: '安全第一',
      description:
        '采用银行级加密技术和多重安全防护体系，确保用户信息和资金绝对安全。我们始终将用户安全视为平台生存的根本。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '公平透明',
      description:
        '所有游戏均采用国际认证的随机数生成器，定期接受第三方审计，确保游戏结果公平公正，规则透明公开。',
      icon: 'ri-scales-line',
    },
    {
      title: '用户至上',
      description:
        '从产品设计到客户服务，始终站在用户角度思考问题。7×24小时全天候客服团队，随时为用户排忧解难。',
      icon: 'ri-heart-line',
    },
    {
      title: '创新进取',
      description:
        '持续投入技术研发，不断优化产品体验，引进最新游戏内容，确保平台始终保持行业领先地位。',
      icon: 'ri-rocket-line',
    },
  ],
  milestones: [
    { year: '2018', event: 'j9平台正式成立，开启综合娱乐服务新篇章' },
    { year: '2019', event: '注册用户突破50万，获行业新锐平台奖' },
    { year: '2020', event: '游戏种类突破1000款，推出移动端H5版本' },
    { year: '2021', event: '注册用户突破200万，上线真人视讯和电竞板块' },
    { year: '2022', event: '获国际安全认证，推出VIP会员体系' },
    { year: '2023', event: '注册用户突破400万，全面升级安全防护体系' },
    { year: '2024', event: '推出智能推荐系统，用户满意度达98.5%' },
    { year: '2025', event: '注册用户突破500万，获年度最受用户信赖平台' },
  ],
  reputationStats: [
    { value: '500万+', label: '累计注册用户' },
    { value: '98.5%', label: '用户满意度' },
    { value: '99.9%', label: '支付成功率' },
    { value: '4.9/5', label: '综合评分' },
  ],
  certificates: [
    {
      title: '国际安全认证',
      description: '通过国际权威安全认证机构审核，符合全球信息安全标准',
    },
    {
      title: '公平游戏认证',
      description: '游戏随机数生成器通过第三方实验室认证，确保公平公正',
    },
    {
      title: '正规运营牌照',
      description: '持有合法运营牌照，受监管机构监督，运营合规合法',
    },
  ],
  contactInfo: {
    phone: '400-888-9999',
    email: 'service@j9guanwang.com',
    wechat: 'j9guanfang',
    workingHours: '7×24小时全天候服务',
    address: '请通过官方网站获取最新办公地址信息',
  },
};

export const aboutFaqs = [
  {
    question: 'j9平台的运营资质是否正规？',
    answer:
      'j9平台持有国际正规运营牌照，所有经营活动均严格遵守相关法律法规。平台定期接受第三方审计和监管机构检查，确保各项业务合法合规运营。您可以放心在j9平台进行娱乐活动。',
  },
  {
    question: 'j9平台的用户隐私如何保护？',
    answer:
      'j9平台严格遵守用户隐私保护相关法规，采用银行级数据加密技术存储用户信息。平台承诺不会向任何第三方出售、泄露或共享您的个人信息，所有数据处理均在安全可控的环境中进行。',
  },
  {
    question: 'j9平台如何处理用户投诉？',
    answer:
      'j9平台建立了完善的用户投诉处理机制。用户可通过在线客服、电话、邮件等渠道提交投诉，客服团队将在1小时内响应。所有投诉均会进入工单系统进行跟踪处理，确保件件有回应、事事有着落。',
  },
  {
    question: 'j9平台如何进行负责任娱乐引导？',
    answer:
      'j9平台积极倡导负责任的娱乐理念，为用户提供自我限制工具，包括充值限额、游戏时间提醒、自我排除等功能。我们致力于营造健康、理性的娱乐环境，帮助用户建立正确的娱乐观念。',
  },
];